import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import './styles.css';
import { ReactComponent as VolumeIcon } from '../../assets/images/volumeIcon.svg';
import { ReactComponent as VolumeMuteIcon } from '../../assets/images/volumeMuteIcon.svg';
import { deviceMaxWidth, deviceMinWidth } from '../../constants';

interface IProps {
  setVolume: (value: number) => void;
  volume: number;
}

export default function Volume(props: IProps) {
  const styles = useStyles();
  const { setVolume, volume } = props;
  const isMute = +volume === 0;

  return (
    <div className={styles.volumeContainer}>
      <input
        type="range"
        value={volume}
        step="0.05"
        min="0"
        max="1"
        className="volume"
        onChange={(e) => setVolume(+e.target.value)}
      />
      {isMute ? (
        <VolumeMuteIcon className={styles.icon} />
      ) : (
        <VolumeIcon className={styles.icon} />
      )}
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  volumeContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',

    [deviceMinWidth.size501]: {
      [deviceMaxWidth.size768]: {
        display: 'none',
      },
    },
  },
  icon: {
    margin: '0 10px',
    height: 21,

    [deviceMinWidth.size769]: {
      [deviceMaxWidth.size1024]: {
        height: 18,
      },
    },
  },
}));
